module.exports = __webpack_public_path__ + "static/media/pic6.e0293c88.jpg";